<template>
  <Screen>
    <AppBar :title="title" />
    <Breadcrumbs
      :links="[
        {
          to: $route('admin.splashscreens.index'),
          title: 'Splash screens',
        },
      ]"
      :title="title"
    />
    <div class="row">
      <div class="col-lg-6">
        <div class="card card-body">
          <form action="" method="post" @submit.prevent="submit" v-if="formSet">
            <TextBox
              name="title"
              v-model="form.title"
              :disabled="form.processing"
              :error="form.errors.title"
            />
            <TextBox
              name="sort_order"
              v-model="form.sort_order"
              :disabled="form.processing"
              :error="form.errors.sort_order"
              helperText="Higher the number, higher the priority"
            />
            <TextBox
              type="textarea"
              name="description"
              v-model="form.description"
              :disabled="form.processing"
              :error="form.errors.description"
            />
            <FileInput
              name="thumbnail"
              v-model="form.thumbnail"
              :fileUrl="form.thumbnail_url"
              :disabled="form.processing"
              :error="form.errors.thumbnail"
              helperText="Upload svg file for better quality"
            />
            <StatusRadio
              v-model="form.isactive"
              :disabled="form.processing"
              :error="form.errors.isactive"
            />
            <div class="mt-4 text-center">
              <button
                class="btn btn-primary w-25"
                type="submit"
                :disabled="form.processing"
                @click.prevent="submit"
              >
                <div
                  class="spinner-border spinner-border-sm"
                  role="status"
                  v-if="form.processing"
                ></div>
                <span v-else>Save</span>
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </Screen>
</template>
<script>
import FileInput from "@/components/form/fileInput.vue";

export default {
  props: {
    title: {
      type: String,
      default: "",
    },
    formData: {
      type: [Object, Array],
      default: () => {},
    },
    submitUrl: {
      type: String,
      default: "",
    },
    editMode: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    FileInput,
  },
  data() {
    return {
      form: {},
      formSet: false,
    };
  },
  mounted() {
    setTimeout(() => {
      this.form = this.$inertia.form(this.formData);
      this.form.thumbnail = null;
      setTimeout(() => {
        this.formSet = true;
      });
    });
  },
  methods: {
    submit() {
      this.form.post(this.submitUrl, {
        onSuccess: () => this.form.reset(),
      });
    },
  },
};
</script>